export default __webpack_public_path__ + "static/media/coingecko.2276811c.svg";